import { Box } from '@mui/material';
import { pdvScale } from './pdvScale';

// Decoração do fundo do tema Básico — mesma filosofia da LoginTechDecoration
// (100% CSS/MUI, sem imagem): cortes diagonais discretos nos cantos, grade de
// pontos esmaecendo nas bordas (mask) e duas formas rotacionadas (quadrado
// arredondado a 45°) com anéis de box-shadow, uma pra cada lado. O gradiente
// de base (radial + linear, claro/neutro) fica em PDVThemes.ts
// (colors.backgroundImage do tema 'basico') — aqui só as camadas que
// dependem de mask-image/box-shadow, que um background-image comum não
// consegue expressar. Tamanhos/posições das formas em pdvScale (mesma
// escala global do PDV) — sem isso ficavam presos num px fixo, não
// acompanhando a interface encolher/crescer com --pdv-scale.
export const PDVBasicoDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Cortes diagonais nos cantos superior-esquerdo/inferior-direito. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.9,
        background: `
          linear-gradient(135deg, rgba(90, 103, 121, 0.16) 0%, rgba(90, 103, 121, 0.10) 13%, transparent 13%),
          linear-gradient(315deg, rgba(90, 103, 121, 0.13) 0%, rgba(90, 103, 121, 0.08) 12%, transparent 12%)
        `,
      }}
    />

    {/* Grade de pontos — esmaece nas bordas (mask), diagonal como os cortes acima. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.45,
        backgroundImage: 'radial-gradient(circle, rgba(78, 91, 108, 0.22) 2px, transparent 2.5px)',
        backgroundSize: '20px 20px',
        maskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
        WebkitMaskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
      }}
    />

    {/* Forma esquerda — quadrado arredondado a 45°, sangrando pra fora da
        borda esquerda, com dois anéis concêntricos via box-shadow. */}
    <Box
      sx={{
        position: 'absolute',
        left: pdvScale(-260),
        top: pdvScale(80),
        width: pdvScale(380),
        height: pdvScale(380),
        border: '2px solid rgba(81, 95, 112, 0.10)',
        borderRadius: pdvScale(70),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(55)} ${pdvScale(55)} 0 rgba(82, 95, 112, 0.035),
          ${pdvScale(110)} ${pdvScale(110)} 0 rgba(82, 95, 112, 0.025)
        `,
      }}
    />

    {/* Forma direita — espelhada, sangrando pra fora da borda direita. */}
    <Box
      sx={{
        position: 'absolute',
        right: pdvScale(-250),
        bottom: pdvScale(-20),
        width: pdvScale(380),
        height: pdvScale(380),
        border: '2px solid rgba(81, 95, 112, 0.10)',
        borderRadius: pdvScale(70),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(-55)} ${pdvScale(-55)} 0 rgba(82, 95, 112, 0.035),
          ${pdvScale(-110)} ${pdvScale(-110)} 0 rgba(82, 95, 112, 0.025)
        `,
      }}
    />
  </Box>
);
